import is from 'is';
import { bulkUpdate } from './utils/bulkUpdate';
import { useItems } from './utils/ItemsContext';
import { ActionsContent } from './utils/ActionsContent';
import PropTypes from 'prop-types';
import { Input } from '@skyline-platform/alchemy';
import { useMemo, useState } from 'react';
import { validateIPOrFQDN } from '@utils/formValidators';

export const AssignNetworkAddress = ({ title }) => {
  const { cameras, selectedCameras } = useItems();
  const [networkAddr, setNetworkAddr] = useState('');

  const selectedCameraIds = useMemo(
    () => selectedCameras.map((cam) => cam.id),
    [selectedCameras]
  );

  const showWarning = useMemo(() =>
    cameras.some(
      (camera) => camera.network_address === networkAddr &&
        // don't show warning for the cameras being edited
        !selectedCameraIds.includes(camera.id)
    ),
  [
    cameras,
    networkAddr,
    selectedCameraIds,
  ]
  );

  const error = useMemo(() => {
    if (!is.empty(networkAddr)) {
      const validationResult = validateIPOrFQDN(networkAddr, 4);
      return { isValid: validationResult.isValid, error: validationResult.error };
    }
    return { isValid: true, error: '' };
  }, [networkAddr]);

  return (
    <ActionsContent
      title={title}
      description="Enter the network address. Once updated, the selected cameras' network addresses will be updated to the new network address."
      confirmAction={() => bulkUpdate('update_device', selectedCameras, {
        network_address: networkAddr,
      })}
      confirmBtnState={error.isValid && selectedCameras.length > 0 ? 'default' : 'disabled'}
      confirmBtnTitle={
        !error.isValid
          ? error.error || undefined
          : selectedCameras.length === 0
            ? 'No rows selected'
            : undefined
      }
    >
      <Input
        id='input-network-addr'
        helperText='IPv4 address or FQDN'
        value={networkAddr}
        onChange={(e) => setNetworkAddr(e.target.value.trim())}
        useWarning={showWarning}
        warningMessage={`This address is already in use by another connection. Proceeding may result in
                  duplicate streams. If you are setting up multiple cameras or testing, ensure this is intentional.`}
        error={!error.isValid}
        errorMessage={error.error}
      />
    </ActionsContent>
  );
};

AssignNetworkAddress.propTypes = {
  title: PropTypes.string.isRequired,
};